import ButtonSkeleton, { ButtonSkeletonProps } from '../../components/Button/skeleton';

export interface ToolbarButtonSkeletonProps extends ButtonSkeletonProps {}

const ToolbarButtonSkeleton = ({ ...props }: ToolbarButtonSkeletonProps) => {
  return <ButtonSkeleton size="small" {...props} />;
};

export default ToolbarButtonSkeleton;
